import { ChevronLeft, ChevronRight } from 'lucide-react'

/** Las páginas a mostrar: la primera, la última y las vecinas de la actual; `null` = salto. */
function paginasVisibles(pagina: number, paginas: number): (number | null)[] {
  const set = new Set([1, paginas, pagina - 1, pagina, pagina + 1].filter((p) => p >= 1 && p <= paginas))
  const orden = [...set].sort((a, b) => a - b)
  return orden.flatMap((p, i) => (i > 0 && p - orden[i - 1] > 1 ? [null, p] : [p]))
}

/** Paginación del kit (`dcc-pagination`). No se muestra si hay una sola página. */
export function Paginacion({ pagina, paginas, onCambiar }: { pagina: number; paginas: number; onCambiar: (pagina: number) => void }) {
  if (paginas <= 1) return null
  return (
    <nav className="dcc-pagination" aria-label="Páginas">
      <button type="button" className="dcc-pagination__btn" disabled={pagina <= 1} onClick={() => onCambiar(pagina - 1)} aria-label="Página anterior">
        <ChevronLeft className="dcc-i" aria-hidden />
      </button>
      {paginasVisibles(pagina, paginas).map((p, i) =>
        p === null ? (
          <span key={`salto-${i}`} className="dcc-pagination__gap" aria-hidden>…</span>
        ) : (
          <button
            key={p}
            type="button"
            className="dcc-pagination__btn"
            aria-current={p === pagina ? 'page' : undefined}
            onClick={() => onCambiar(p)}
          >
            {p}
          </button>
        ),
      )}
      <button type="button" className="dcc-pagination__btn" disabled={pagina >= paginas} onClick={() => onCambiar(pagina + 1)} aria-label="Página siguiente">
        <ChevronRight className="dcc-i" aria-hidden />
      </button>
    </nav>
  )
}
